<template>
    <div v-if="showDialog" class="dialog">
      <div class="dialog-content">
        <p>{{ label }} : {{ progress }}%</p>
        <div class="progress-bar">
          <div class="progress" :style="{ width: progress + '%' }"></div>
        </div>
        <p>{{ item }}</p>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    data() {
      return {
        progress: 0, // Pourcentage actuel
        showDialog: false, // Contrôle de la boîte de dialogue
        max: 100,
        label: '',
        step: 1,
      };
    },
    methods: {
      startProgress(max, label) {
        this.progress = 0
        this.max = max || 100
        this.showDialog = true
        this.label = label || 'Chargement en cours'
        this.item = ''
        this.step = 100/parseInt(max)
        console.log("max", this.max)
        console.log("step", this.step)
      },
      incrementProgress(item) {
        this.progress = parseInt(this.progress + this.step); // Incrémente la progression
        this.item = item
        console.log(this.progress)
      },
      stopProgress() {
        this.progress = 100
        setTimeout(() => {
              this.showDialog = false; // Ferme la boîte de dialogue
            }, 500);
      }
    },
  };
  </script>
  
  <style>
  .dialog {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
  }
  
  .dialog-content {
    background: white;
    min-width: 300px;
    padding: 20px;
    border-radius: 10px;
    text-align: center;
  }
  
  .progress-bar {
    width: 100%;
    height: 20px;
    background: #f3f3f3;
    border-radius: 10px;
    overflow: hidden;
    margin-top: 10px;
  }
  
  .progress {
    height: 100%;
    background: #4caf50;
    transition: width 0.1s ease;
  }
  </style>
  